import styled, { css } from "styled-components";
import type { RadioVariantsType } from "./Radio";

export const InputWrapper = styled.div<{ isChecked?: boolean; isDisabled?: boolean }>`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 3.2rem;
    aspect-ratio: 1;
    background: var(--color-primary-white);
    border: 1px solid var(--color-grey-6);
    border-radius: 50%;
    transition:
        background 0.3s,
        border-color 0.3s;
    cursor: pointer;
    svg {
        display: none;
        width: 1.4rem;
        aspect-ratio: 1;
        color: var(--color-primary-white);
    }
    ${({ isChecked }) =>
        isChecked &&
        css`
            background: var(--color-primary-black);
            border-color: var(--color-primary-black);
            svg {
                display: block;
            }
        `};
    ${({ isDisabled }) =>
        isDisabled &&
        css`
            background: var(--color-grey-7);
            border-color: var(--color-grey-7);
            svg {
                display: block;
            }
        `};
`;
// STYLES
const RadioStyle = css`
    display: flex;
    align-items: center;
    gap: calc(var(--spacing-3) / 2);
    input {
        position: absolute;
        width: 100%;
        aspect-ratio: 1;
        cursor: pointer;
        opacity: 0;
    }
    label {
        cursor: pointer;
    }
`;

const basic = css`
    ${RadioStyle};
`;

// COMPONENTS
export const RadioVariants = {
    basic,
};

const RadioVariant = styled.div<{ variant: RadioVariantsType }>`
    ${({ variant }) =>
        variant &&
        css`
            ${RadioVariants[variant]};
        `};
`;

export default RadioVariant;
